import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { PRODUCT_RATING, PRODUCT_REVIEWS, REVIEW_DETAILS } from '@estee/elc-service-view-names';
import serviceNames, { RatingsReviewsService } from '~setup/RatingsReviewsService';
import { serviceBusBaseClass } from '~setup/ServiceBus';

import './exported/product-rating/index';
import './exported/product-reviews/index';
import './exported/review-details/index';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

RatingsReviewsService.setViews(name, getModuleFederatedName(name), version, [
    PRODUCT_RATING,
    PRODUCT_REVIEWS,
    REVIEW_DETAILS
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.ratingsReviewsService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});
